export default __webpack_public_path__ + "static/media/Icono11.cf71895a.svg";